import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useTodayReward() {
  return useQuery({
    queryKey: ['today-reward'],
    queryFn: async () => {
      const { data } = await api.get('/rewards/today');
      return data;
    },
  });
}

export function useClaimReward() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('/rewards/claim'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['today-reward'] });
      queryClient.invalidateQueries({ queryKey: ['user-profile'] });
      queryClient.invalidateQueries({ queryKey: ['user-dashboard'] });
    },
  });
}

export function useRewardHistory() {
  return useQuery({
    queryKey: ['reward-history'],
    queryFn: async () => {
      const { data } = await api.get('/rewards/history');
      return data;
    },
  });
}
